import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, UnstyledButton, Text, Flex, Grid } from "@mantine/core";
import toast from "react-hot-toast";
import { IconMap2, IconCheck } from "@tabler/icons-react";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";

import EntrySummary from "@components/Microsite/EntrySummary";
import useAppStore from "@components/Microsite/microsite-store";
import { NavButton } from "./RideChallengeDashboard";

export default function RideChallengeCheckInButton({
  onSuccess,
  onNoLocation = () => true,
  onLocation,
}) {
  const { t } = useTranslation();
  const [summary, setSummary] = useState(null);
  const [locationId, setLocationId] = useState(null);

  const { campaignId, entityInfo, coords, user } = useAppStore(
    (state) => ({
      campaignId: state.campaignId,
      coords: state.coords,
      entityInfo: state.entityInfo,
      user: state.user,
    }),
    shallow
  );

  if (!coords) return null;

  useEffect(() => {
    fetchLocation();
  }, []);

  function fetchLocation() {
    const req = {
      campaign_effort_id: entityInfo.campaign_effort_id,
      campaign_id: campaignId,
      latitude: coords.latitude,
      longitude: coords.longitude,
    };

    if (entityInfo.location) {
      req.location_id = entityInfo.location.id;
    }

    axios
      .post(`/microsite/location-point-check/`, req)
      .then(({ data }) => {
        if (data.response.length) {
          setLocationId(data.response[0].id);
        } else {
          onNoLocation();
        }
      })
      .catch((err) => {
        setLocationId(null);
      });
  }

  function onClick() {
    const req = {
      ...coords,
      user_id: user.id,
      campaign_id: campaignId,
      campaign_effort_id: entityInfo.campaign_effort_id,
      location_id: locationId,
    };

    axios
      .post(`/microsite/location-check-in/`, req)
      .then(({ data }) => {
        if (data.response[0].results) {
          setSummary(data.response[0].results);
        } else {
          toast.success("Checked In!");
          onSuccess();
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  if (!locationId) return null;

  if (user && !user.allow_check_in) {
    return (
      <Grid.Col span={12}>
        <UnstyledButton style={{ width: "100%" }}>
          <NavButton color="gray.1" hasAlert={false}>
            <Flex align="center" gap="xs" justify="center">
              <IconCheck size={28} color="#000" />
              <Text size="sm" fw={600}>
                {t("microsite:checked_in")}
              </Text>
            </Flex>
          </NavButton>
        </UnstyledButton>
      </Grid.Col>
    );
  }

  return (
    <Grid.Col span={12}>
      {summary && (
        <EntrySummary
          results={summary}
          checkin
          onClose={() => {
            setSummary(null);
            onSuccess();
          }}
        />
      )}
      <UnstyledButton style={{ width: "100%" }} onClick={onClick}>
        <NavButton color="gray.1" hasAlert={false}>
          <Flex align="center" gap="xs" justify="center">
            <IconMap2 size={28} color="#000" />
            <Text size="sm" fw={600}>
              {t("microsite:check_in_button")}
            </Text>
          </Flex>
        </NavButton>
      </UnstyledButton>
    </Grid.Col>
  );
}
